import React, { useState, useRef, useEffect } from 'react';
import sort from '/src/assets/sort.svg';
import relevance from '/src/assets/relevance.svg';
import az from '/src/assets/az.svg';
import za from '/src/assets/za.svg';
import highintent from '/src/assets/highintent.svg';

interface SortProps {
  onClick?: () => void;
  onSortChange?: (sortOption: string) => void;
}

const Sort: React.FC<SortProps> = ({ onClick, onSortChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSortOptionClick = (option: string) => {
    setIsOpen(false);
    if (onSortChange) {
      onSortChange(option);
    }
  };

  return (
    <div ref={dropdownRef} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center h-[28px] gap-2 px-2 py-1 text-[#7A7A7A] bg-[#FAFAFA] border border-[#E6E7EA] rounded-lg hover:bg-[#F5F5F5]"
      >
        <img src={sort} alt="sort" className="w-[14px] h-[14px]" />
        <span className="text-[14px] font-normal">Sort by</span>
      </button>

      {isOpen && (
        <div className="absolute left-0 mt-2 w-[123px] bg-[#FFFFFF] border border-[#EEEEEE] rounded-lg shadow-lg z-10">
          <div className="flex flex-col gap-2">
            <button
              className="flex items-center gap-1 w-full px-2 py-2 text-left text-sm text-[#222222] hover:bg-[#F5F5F5] hover:cursor-pointer hover:rounded-lg font-normal"
              onClick={() => handleSortOptionClick('created_at__desc')}
            >
              <img src={relevance} alt="relevance" className="w-[14px] h-[14px]" />
              Relevance
            </button>
            <button
              className="flex items-center gap-1 w-full px-2 py-2 text-left text-sm text-[#222222] hover:bg-[#F5F5F5] font-normal"
              onClick={() => handleSortOptionClick('name__asc')}
            >
              <img src={az} alt="az" className="w-[14px] h-[14px]" />
              A-Z
            </button>
            <button
              className="flex items-center gap-1 w-full px-2 py-2 text-left text-sm text-[#222222] hover:bg-[#F5F5F5] font-normal"
              onClick={() => handleSortOptionClick('name__desc')}
            >
              <img src={za} alt="za" className="w-[14px] h-[14px]" />
              Z-A
            </button>
            <button
              className="flex items-center gap-1 w-full px-2 py-2 text-left text-sm text-[#222222] hover:bg-[#F5F5F5] font-normal"
              onClick={() => handleSortOptionClick('score__desc')}
            >
              <img src={highintent} alt="highintent" className="w-[14px] h-[14px]" />
              High intent
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sort;
